import { Button, Form, FormInstance, Input } from 'antd';
import { setStoredInput } from 'presentation/redux/features/CU/CU03101Slice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { MAX_NUMBER_VALUE_6_DIGITAL } from '..';
import { CountStep } from './CountStep';
import { InputWholeNumber } from './Input';

interface props {
    form: FormInstance<any>;
}
export const StepFour = ({ form }: props) => {
    const dispatch = useAppDispatch();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    const onNext = () => {
        const newStoredInput = {
            ...storedInput,
            managementFee: form.getFieldValue('managementFee'),
            renovationDeposit: form.getFieldValue('renovationDeposit'),
            otherExpenses: form.getFieldValue('otherExpenses'),
            otherExpensesNotes: form.getFieldValue('otherExpensesNotes'),
            page: 4,
            prev: false,
            submit: true,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    const onBack = () => {
        const newStoredInput = {
            ...storedInput,
            page: 4,
            prev: true,
            submit: true,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    return (
        <React.Fragment>
            <CountStep current={4} title="管理費など（支出）を入力してください。" />
            <InputWholeNumber
                label="管理費"
                name="managementFee"
                isRequired
                requiredMessage="管理費を入力してください。"
                addonAfter="円"
                placeholder={PLACEHOLDER.MANAGEMENT_FEE}
                max={MAX_NUMBER_VALUE_6_DIGITAL}
            />
            <InputWholeNumber
                label="修繕積立金"
                name="renovationDeposit"
                isRequired
                requiredMessage="修繕積立金を入力してください。"
                addonAfter="円"
                placeholder={PLACEHOLDER.RESERVE_FUND_FOR_REPAIRS}
                max={MAX_NUMBER_VALUE_6_DIGITAL}
            />
            <InputWholeNumber
                label="その他費用（インターネット使用料など）（任意）"
                name="otherExpenses"
                isRequired={false}
                addonAfter="円"
                placeholder={PLACEHOLDER.OTHER_EXPENSES}
                max={MAX_NUMBER_VALUE_6_DIGITAL}
            />
            {!!form.getFieldValue('otherExpenses') && (
                <section style={{ width: '100%', marginTop: 24 }} className="input-number-custom">
                    <div style={{ marginBottom: 16 }} className="label-form">
                        その他費用備考
                        {!!form.getFieldValue('otherExpenses') && (
                            <span style={{ color: '#EB5757' }}>*</span>
                        )}
                    </div>
                    <Form.Item
                        required={true}
                        className="input-font-style-2 label-form-style "
                        name="otherExpensesNotes"
                        label={false}
                        rules={[
                            {
                                required: !!form.getFieldValue('otherExpenses'),
                                message: getMessage('In_Required', 'その他費用備考'),
                            },
                        ]}
                    >
                        <Input.TextArea
                            maxLength={3000}
                            style={{ height: 160, resize: 'none' }}
                            placeholder={PLACEHOLDER.COST_NOTES}
                        />
                    </Form.Item>
                    {/* <div style={{color: '#ff4d4f', marginTop: '-24px'}}>{!form.getFieldValue('otherExpensesNotes') && 'その他費用備考を入力してください。'}</div> */}
                </section>
            )}
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                    gap: 20,
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        marginTop: 16,
                        color: '#28323C',
                    }}
                    onClick={() => onBack()}
                >
                    戻る
                </Button>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: 165.5, height: 56, marginTop: 16 }}
                    onClick={() => onNext()}
                    htmlType="submit"
                >
                    次へ
                </Button>
            </section>
        </React.Fragment>
    );
};
